import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import { useState, useContext, createContext } from 'react';
import { OrderDir } from '../../domain/enums/order-dir.js';

const DiscussionContext = /*#__PURE__*/createContext({});
const useDiscussion = () => {
  return useContext(DiscussionContext);
};
/**@todo: change provider name (managment? manager?) */
const DiscussionProvider = ({
  type,
  metadata,
  children,
  discussionOwnerId,
  currentUser
}) => {
  const [orderDir, setOrderDir] = useState(OrderDir.DESC);
  const isDiscussionOwner = discussionOwnerId === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
  const isOwnerOfComment = commentOwnerId => {
    return commentOwnerId === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
  };
  return jsx(DiscussionContext.Provider, Object.assign({
    value: {
      type,
      metadata,
      discussionOwnerId,
      currentUser,
      isDiscussionOwner,
      isOwnerOfComment,
      orderDir,
      setOrderDir
    }
  }, {
    children: children
  }));
};

export { DiscussionProvider, useDiscussion };
